import { render, staticRenderFns } from "./ProductMatchSearch.vue?vue&type=template&id=593cb130&"
import script from "./ProductMatchSearch.vue?vue&type=script&lang=js&"
export * from "./ProductMatchSearch.vue?vue&type=script&lang=js&"
import style0 from "./ProductMatchSearch.vue?vue&type=style&index=0&id=593cb130&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports